import { render, staticRenderFns } from "./BatchSettingLog.vue?vue&type=template&id=809175b8&scoped=true"
import script from "./BatchSettingLog.vue?vue&type=script&lang=js"
export * from "./BatchSettingLog.vue?vue&type=script&lang=js"
import style0 from "./BatchSettingLog.vue?vue&type=style&index=0&id=809175b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809175b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('809175b8')) {
      api.createRecord('809175b8', component.options)
    } else {
      api.reload('809175b8', component.options)
    }
    module.hot.accept("./BatchSettingLog.vue?vue&type=template&id=809175b8&scoped=true", function () {
      api.rerender('809175b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/BatchSettingLog.vue"
export default component.exports